import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { getInstallation } from '../../../../../config/installation';
import { isDataResidencyVisible } from '../../../../../config/features';
import { goToRoute, ROUTES } from '../../../../../router/urls';

const Badge = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    height: 34px;
    padding: 0 12px;
    margin-right: 14px;
    border: 1px solid #dce3ea;
    border-radius: 17px;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        border-color: #b9c4d0;
    }

    .installation-country {
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.4px;
        color: #2e3a59;
    }

    .installation-tenant {
        font-size: 11px;
        color: #8a94a6;
    }

    .installation-dot {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #2fbf71;
    }
`;

/**
 * Which installation the operator is signed in to, shown on every screen.
 *
 * A bank evaluating data residency should never have to take it on trust that
 * they are looking at the DRC installation rather than the Tanzanian one, so
 * the country and tenant code stay on screen rather than living in a settings
 * page nobody opens.
 */
const InstallationBadge = () => {
    const history = useHistory();
    const installation = getInstallation();

    /*
     * The badge is the only way to the residency screen, so it goes when that
     * screen does — a build without it would otherwise carry a badge naming an
     * installation, in the corner of every page, that leads to a 404.
     */
    if (!isDataResidencyVisible()) {
        return null;
    }

    return (
        <Badge
            onClick={() => history.push(goToRoute(ROUTES.DATA_RESIDENCY))}
            title="Data residency and tenant isolation"
        >
            <span className="installation-dot" />
            <span className="installation-country">{installation.primaryCountry}</span>
            <span className="installation-tenant">{installation.tenantCode}</span>
        </Badge>
    );
};

export default InstallationBadge;
